import { trackEvent } from '@/lib/omega'

class Omega {
  install(Vue) {
    Vue.prototype.$trackEvent = trackEvent
  }
}

export default new Omega()
